import { useEffect, Fragment } from "react";
import { connect } from "react-redux";
import { getShops, activeFlashSale } from "actions/shopPromotionActions";
import { ReactTable } from "components/Table";
import { useTranslation } from "react-i18next";

const ShopPromotion = ({ getShops, shopPromotion, activeFlashSale }) => {

    const { t } = useTranslation();
    const { list } = shopPromotion;

    useEffect(() => {
        getShops({ page: 1, sizeperpage: 9999, pathname: "analytic" });
    }, [getShops]);
    const columns = [
        {
            dataField: "_id",
            text: "",
            sort: true,
            formatter: (cell, row, rowIndex) => rowIndex + 1,
        },
        {
            dataField: "shops",
            text: t("Note"),
            sort: true,
            formatter: (cell, row) => <span data-tooltip-id="my-tooltip"
                data-tooltip-content={row?.name}>{cell?.note || row?.name || row?.code || ""}</span>,
        },
        {
            dataField: "expiredAtLong",
            text: t("Expired At"),
            sort: true,
            formatter: (cell, row) => {
                if (!cell || isNaN(cell)) return <span style={{ color: "#999" }}>Unknown</span>;

                const now = Date.now();
                const diffMs = cell - now;
                const diffHours = diffMs / (1000 * 60 * 60);
                const diffDays = Math.floor(diffHours / 24);

                // Trường hợp 1: Hết trong 2 ngày tới → màu xanh dương
                if (diffHours > 0 && diffHours <= 48) {
                    return (
                        <span style={{ color: "dodgerblue", fontWeight: "bold" }}>
                            Expiring in {Math.ceil(diffHours)} hours
                        </span>
                    );
                }

                // Trường hợp 2: Hết hạn sau vài giờ (âm nhưng nhỏ hơn 24h) → vàng đậm
                if (diffHours <= 0 && diffHours > -24) {
                    return (
                        <span style={{ color: "#d4a017", fontWeight: "bold" }}>
                            Expired {Math.abs(Math.floor(diffHours))} hours ago
                        </span>
                    );
                }

                // Trường hợp 3: Đã hết hạn lâu hơn 1 ngày → màu đỏ
                if (diffHours <= -24) {
                    return (
                        <span style={{ color: "red", fontWeight: "bold" }}>
                            Expired {Math.floor(Math.abs(diffDays))} days ago
                        </span>
                    );
                }

                // Trường hợp khác: Còn nhiều hơn 2 ngày
                return (
                    <span style={{ color: "#333" }}>
                        Expires in {Math.ceil(diffDays)} days
                    </span>
                );
            },
        },
        {
            dataField: "-",
            text: t("Actions"),
            sort: true,
            formatter: (cell, row) => <Fragment>
                <button
                    onClick={() => {
                        // Handle reconnect action here
                        if (row?.premium !== true) {
                            return activeFlashSale({ shops: [row?._id?.toString()], page: 1, sizePerPage: 9999, type: "72h", pathname: "analytic" });
                        } else {
                            return activeFlashSale({ shops: [row?._id?.toString()], page: 1, sizePerPage: 9999, type: "11h", pathname: "analytic" });
                        }
                    }}
                    className="btn btn-icon btn-bg-light btn-active-color-warning btn-sm me-2"
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content={t("Renew")}
                >
                    <i className="ki-outline ki-disk fs-3"></i>
                </button>
            </Fragment>,
        },
    ];
    return (
        <div className="card card-body">
            <h3 className="mb-5 text-danger"> <i className="ki-outline ki-rocket fs-2 me-2"></i> <b>Flash Sale Expiration Warnings</b></h3>
            <ReactTable
                columns={columns}
                data={list}
                isSearchBar={false}
                page={1}
                sizePerPage={9999}
            />
        </div>
    );
};

const mapStateToProps = (state) => ({
    shopPromotion: state.shopPromotion,
});
const mapDispatchToProps = { getShops, activeFlashSale };

export default connect(mapStateToProps, mapDispatchToProps)(ShopPromotion);
